import { Box, ButtonBase, Typography } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import CustomCheckBox from "./CustomCheckBox";
import { initCurate } from "../../Editor/itemTypes";
import { useContext } from "react";
import TreeContext from "./treeContext";

export default function CurateTreeItem({
  node,
  isExpanded,
  position,
  indentLevel,
}) {
  const {
    locked,
    variant,
    isCurate,
    handleSelect,
    handleUpdateItem,
    handleToggle,
  } = useContext(TreeContext);
  const indentMargin = `${(indentLevel.split(".").length - 2) * 45}px`;
  // curate
  const isCurateQuestion = isCurate && node.original?.itemExtra?.curate;
  const curate = node.original?.itemExtra?.curate ?? initCurate;
  const showCheckbox = isCurateQuestion && Boolean(curate.show);
  const hideTree = isCurateQuestion && Boolean(curate.hideTree);
  const title =
    !locked && curate.title === ""
      ? `${node.title} [${node.label}] - ${node.type}`
      : curate.title;

  return (
    <Box display={"flex"} sx={{ gap: 1 }} marginLeft={indentMargin}>
      <Box paddingTop={"4px"}>
        {showCheckbox && curate.allowHide ? (
          <CustomCheckBox
            disabled={locked}
            checked={node.checked}
            handleSelect={() => {
              handleSelect(position, !node.checked);
              handleUpdateItem(node, position, { checked: !node.checked });
            }}
          />
        ) : (
          <Box padding={1} color="text.secondary">
            <InfoOutlinedIcon />
          </Box>
        )}
      </Box>
      <ButtonBase
        sx={{
          display: "flex",
          justifyContent: "start",
          gap: 1,
          borderRadius: 1,
          padding: 1,
        }}
        onClick={() => handleToggle(node)}
        disabled={hideTree || node.items.length === 0}
      >
        <Box textAlign={"left"}>
          <Box display={"flex"} sx={{ gap: 1 }}>
            <Typography variant={variant}>{title}</Typography>
            {node.items.length > 0 && !hideTree ? (
              isExpanded ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )
            ) : null}
          </Box>
          <Typography variant="body2" color="text.secondary">
            {curate.info}
          </Typography>
        </Box>
      </ButtonBase>
    </Box>
  );
}
